import styled from 'styled-components';

// 공통 레이아웃
export const Wrap = styled.div`
  width: 100%;
  min-height: 100vh;
`;
export const ModalBg = styled.div`
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
`;
export const MainCntAreaLayout = styled.div`
  width: 100%;
  height: calc(100vh - 100px);
  background-color: #f2f4f6;
`;
export const MainCntLayout = styled.div`
  width: 100%;
  min-height: calc(100% - 66px);
  max-height: calc(100% - 66px);
  overflow-y: auto;
  box-sizing: border-box;
  padding: 16px;
`;
export const RoomDetailCntLayout = styled.div`
  width: 100%;
  min-height: calc(100vh - 66px);
  max-height: calc(100vh - 66px);
  box-sizing: border-box;
  padding: 0 16px 20px 16px;
  background: #fff;
`;
export const RoomListBox = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
`;

// 로그인 및 회원가입 레이아웃
export const LoginCntLayout = styled.div`
  width: 100%;
  min-height: calc(100vh - 158px);
  max-height: calc(100vh - 158px);
  overflow-y: auto;
  box-sizing: border-box;
  padding: 24px 20px 0 20px;
`;
export const LoginBtnLayout = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;
  box-sizing: border-box;
  padding: 24px 20px;
`;

const LS = {
  Wrap,
  ModalBg,
  MainCntAreaLayout,
  MainCntLayout,
  RoomDetailCntLayout,
  RoomListBox,
  LoginCntLayout,
  LoginBtnLayout,
};

export default LS;
